import CreditDocumentation from './credit-documentation';

export default CreditDocumentation;
